import { mapToCamelCase } from '@consigli/utils';
import { z } from 'zod';
import { documentPackageSchema } from './document-package';
import { projectSchema } from './project';
export var PipelineStatus;
(function (PipelineStatus) {
    PipelineStatus["STARTED"] = "STARTED";
})(PipelineStatus || (PipelineStatus = {}));
export var JobType;
(function (JobType) {
    JobType["DOCUMENT_PACKAGE"] = "DOCUMENT_PACKAGE";
    JobType["BUILDING_PACKAGE"] = "BUILDING_PACKAGE";
    JobType["LAYOUT_OPTIMIZATION"] = "LAYOUT_OPTIMIZATION";
})(JobType || (JobType = {}));
export var PipelineName;
(function (PipelineName) {
    PipelineName["DEFAULT"] = "DEFAULT";
    PipelineName["VALIDATION_ONLY"] = "VALIDATION_ONLY";
    PipelineName["PRE_PARSING_ONLY"] = "PRE_PARSING_ONLY";
    PipelineName["PARSING_ONLY"] = "PARSING_ONLY";
    PipelineName["POST_PARSING_ONLY"] = "POST_PARSING_ONLY";
    PipelineName["TEXT_PROCESSING_ONLY"] = "TEXT_PROCESSING_ONLY";
    PipelineName["VALIDATION_TO_POST_PARSING"] = "VALIDATION_TO_POST_PARSING";
    PipelineName["VALIDATION_TO_TEXT_PROCESSING"] = "VALIDATION_TO_TEXT_PROCESSING";
    PipelineName["IFC_EXTRACTION_ONLY"] = "IFC_EXTRACTION_ONLY";
    PipelineName["IFC_EXPORT"] = "IFC_EXPORT";
    PipelineName["CEILING_GRID_OPTIMIZATION_ONLY"] = "CEILING_GRID_OPTIMIZATION_ONLY";
    PipelineName["DUCT_ROUTING_ONLY"] = "DUCT_ROUTING_ONLY";
    PipelineName["APARTMENT_ROUTING_ONLY"] = "APARTMENT_ROUTING_ONLY";
    PipelineName["CORRIDOR_ROUTING_ONLY"] = "CORRIDOR_ROUTING_ONLY";
    PipelineName["COMPARISON"] = "COMPARISON";
    PipelineName["REPORT_GENERATION_PRECHECK"] = "REPORT_GENERATION_PRECHECK";
    PipelineName["REPORT_TEMPLATE_CREATION"] = "REPORT_TEMPLATE_CREATION";
    PipelineName["REPORT_GENERATION"] = "REPORT_GENERATION";
    PipelineName["REPORT_GENERATION_ONLY"] = "REPORT_GENERATION_ONLY";
    PipelineName["PARKING"] = "PARKING";
    PipelineName["PLANT_ROOM"] = "PLANT_ROOM";
    PipelineName["ESCAPE_ROUTE"] = "ESCAPE_ROUTE";
    PipelineName["TEXT_COMPARISON_ONLY"] = "TEXT_COMPARISON_ONLY";
    PipelineName["LOAD_CALCULATION"] = "LOAD_CALCULATION";
    PipelineName["SCHEDULE_CHECK"] = "SCHEDULE_CHECK";
    PipelineName["SCHEDULE_CHECK_ONLY"] = "SCHEDULE_CHECK_ONLY";
    PipelineName["SPACE_ANALYSIS"] = "SPACE_ANALYSIS";
    PipelineName["POST_PROCESSING_ONLY"] = "POST_PROCESSING_ONLY";
    PipelineName["PACKAGE_COMPARISON"] = "PACKAGE_COMPARISON";
    PipelineName["PACKAGE_COMPARISON_ONLY"] = "PACKAGE_COMPARISON_ONLY";
    PipelineName["DOCUMENT_PACKAGE_REPORTS"] = "DOCUMENT_PACKAGE_REPORTS";
    PipelineName["LUMINAIRE_SCHEDULE"] = "LUMINAIRE_SCHEDULE";
    PipelineName["DOCUMENT_PACKAGE_REPORTS_ONLY"] = "DOCUMENT_PACKAGE_REPORTS_ONLY";
    PipelineName["REVIT_GENERATOR"] = "REVIT_GENERATOR";
    // Retained for parsing pipeline jobs created before these processors were retired.
    PipelineName["PARKING_REQUIREMENTS"] = "PARKING_REQUIREMENTS";
    PipelineName["APARTMENT_REQUIREMENTS"] = "APARTMENT_REQUIREMENTS";
    PipelineName["SPEC_REQUIREMENTS_EXTRACTION"] = "SPEC_REQUIREMENTS_EXTRACTION";
    PipelineName["SPEC_REQUIREMENTS_CATEGORIZATION"] = "SPEC_REQUIREMENTS_CATEGORIZATION";
    PipelineName["VERSION_COMPARE"] = "VERSION_COMPARE";
    PipelineName["BID_REVIEW"] = "BID_REVIEW";
    PipelineName["BID_REVIEW_MIRRORING_ONLY"] = "BID_REVIEW_MIRRORING_ONLY";
    PipelineName["METADATA_EXTRACTION_ONLY"] = "METADATA_EXTRACTION_ONLY";
    PipelineName["BID_REVIEW_TEXT_PROCESSING_ONLY"] = "BID_REVIEW_TEXT_PROCESSING_ONLY";
})(PipelineName || (PipelineName = {}));
export const pipelineNameSchema = z.nativeEnum(PipelineName);
export const startPipelineResponseSchema = z
    .object({
    status: z.nativeEnum(PipelineStatus),
    pipeline_job_id: z.string().uuid(),
})
    .strict()
    .transform(mapToCamelCase);
export const startPipelineRequestSchema = z
    .object({
    pipelineName: pipelineNameSchema,
    projectId: projectSchema.innerType().shape.id,
    packageId: documentPackageSchema.innerType().shape.id,
    secondaryPackageId: documentPackageSchema.innerType().shape.id.optional(),
    notify: z.boolean().optional(),
    jobType: z.nativeEnum(JobType),
    metadata: z.record(z.string(), z.any()).optional(),
})
    .strict()
    .transform(mapToCamelCase);
